<template>
    <div :class="shown ? 'show hcol-1' : 'hide hcol-1'">
        <div class="col-12 logo-col hcol-1">
            <div class="logo-ct py-2 hcol-1">
                <img style="width: 100%; max-height: 250px" src="@/assets/img/wingo-logo-teal.svg" alt="">
            </div>
        </div>
    </div>
</template>

<script>
export default {
  components: {
  },
  props: [
      "shown"
  ],
  data () {
    return {
    }
  },
  mounted () {
  },
  created () {
  },
  computed: {
  },
  methods: {
  },
  watch: {
  }
}
</script>

<style scoped lang="scss">
  .hide {
    display: none
  }
</style>